import { useEffect, useRef, useState } from 'react';

import { InputV2, ButtonLoading, SimpleDialog, CustomCaptchaComponent } from 'components';

import { Grid, Button, useMediaQuery } from '@mui/material';
import { useStyles } from './style';
const InquiryOwnerDg = (props) => {
  const classes = useStyles();
  const matches = useMediaQuery('(max-width:600px)');

  //const captachaOwnerRef = useRef();
  const {
    captachaOwnerRef,

    isLoadingOwnerDg,
    isOpenOwnerDg,
    setIsOpenOwnerDg,
    enteredCaptchaOwner,
    setEnteredCaptchaOwner,
    setCaptchaIdOwnerDg,

    ownerValues,
    setOwnerValues,
    userContactInfoFLname,

    methods,
    getBranchOwner,
  } = props;
  const [copyValues, setCopyValues] = useState(null);
  const [disableLoading, setDisableLoading] = useState(false);
  useEffect(() => {
    isOpenOwnerDg && setCopyValues(JSON.stringify(ownerValues));
  }, [isOpenOwnerDg]);

  useEffect(() => {
    if (isLoadingOwnerDg) {
      setTimeout(() => {
        setDisableLoading(true);
      }, 1);
    } else {
      setTimeout(() => {
        setDisableLoading(false);
      }, 200);
    }
  }, [isLoadingOwnerDg]);

  const BtnActions = () => {
    return (
      <>
        <ButtonLoading
          variant="contained"
          color="primary"
          loading={isLoadingOwnerDg}
          name="استعلام"
          disabled={!enteredCaptchaOwner || !enteredCaptchaOwner.trim() || isLoadingOwnerDg}
          onClick={getBranchOwner}
        />

        <Button
          variant="contained"
          disabled={disableLoading}
          onClick={() => {
            setIsOpenOwnerDg(false);
            setTimeout(() => {
              !userContactInfoFLname && setOwnerValues({ userContactInfo: '' });
              userContactInfoFLname && setOwnerValues(JSON.parse(copyValues));
            }, 100);
          }}>
          انصراف
        </Button>
      </>
    );
  };
  return (
    <SimpleDialog
      title={userContactInfoFLname ? 'تغییر مالک' : 'افزودن مالک'}
      open={isOpenOwnerDg}
      actions={<BtnActions />}
    >
   
      <Grid item xs={12} md={12} lg={10}>
        <InputV2
          fullWidth
          errors={methods.formState.errors}
          label="تلفن‌همراه/ایمیل/نام‌کاربری"
          name="userContactInfo"
          register={methods.register}
          control={methods.control}
          onChangeValue={(e) => {
            setOwnerValues({ ...ownerValues, userContactInfo: e?.target?.value });
          }}
          defaultValue={ownerValues?.userContactInfo}
          dir="ltr"
        />
      </Grid>
      <Grid container wrap={matches ? 'wrap' : 'nowrap'}>
        <InputV2
          label="کد امنیتی"
          forceValue={enteredCaptchaOwner}
          onChangeValue={(e) => {
            const value = e.target.value;
            if (value.length > 5) {
              //e.preventDefault();
              setEnteredCaptchaOwner(value.slice(0, 5));
            } else {
              setEnteredCaptchaOwner(value);
            }
          }}
          englishNumber
          rules={['isNumeric']}
          fullWidth
          dir="ltr"
        />
        <CustomCaptchaComponent
          pageTitle="/Branch/Add - ایجاد شعبه - دیالوگ افزودن نماینده"
          ref={captachaOwnerRef}
          setCaptchaId={setCaptchaIdOwnerDg}
          setEnteredCaptcha={setEnteredCaptchaOwner}
          sizeOptions={{ xs: '12', md: '10', lg: '10' }}
        />
      </Grid>
    </SimpleDialog>
  );
};

export default InquiryOwnerDg;
